/**
 * ApplicationLogsClient
 * SignalR client for Application Logs Hub (/hubs/application-logs)
 * Handles real-time application log streaming with filtering
 */
import { BaseLogsClient } from './BaseLogsClient';
/**
 * Application logs hub client
 */
export class ApplicationLogsClient extends BaseLogsClient {
    constructor(baseUrl, getToken, options = {}) {
        const hubUrl = `${baseUrl}/hubs/application-logs`;
        super(hubUrl, getToken, options);
    }
    /**
     * Setup server-side method handlers
     */
    setupServerMethods() {
        if (!this.connection)
            return;
        // Receive real-time log entries
        this.connection.on('ReceiveApplicationLog', (log) => {
            this.addLogToBuffer(log);
            this.emit('log', log);
        });
    }
    /**
     * Subscribe to application logs with filter
     */
    async subscribe(filter = {}) {
        this.currentFilter = filter;
        await this.invoke('SubscribeToApplicationLogs', filter.serviceNames || [], filter.logLevels || []);
        this.isSubscribed = true;
    }
    /**
     * Unsubscribe from application logs
     */
    async unsubscribe() {
        await this.invoke('UnsubscribeFromApplicationLogs');
        this.isSubscribed = false;
        this.currentFilter = null;
    }
    /**
     * Get recent application logs
     */
    async getRecent(limit = 100) {
        return await this.invoke('GetRecentApplicationLogs', limit);
    }
}
//# sourceMappingURL=ApplicationLogsClient.js.map